// src/components/StagingHandleCard.tsx

import { useState } from 'react';
import { CPItem } from './ContactPointsPanel';

interface StagingHandleCardProps {
  item: CPItem;
  onConfirm: (item: CPItem) => Promise<void>;
  onRemove: (item: CPItem) => Promise<void>;
}

export function StagingHandleCard({ item, onConfirm, onRemove }: StagingHandleCardProps) {
  const [hov,   setHov]   = useState(false);
  const [press, setPress] = useState(false);

  return (
    <div className="p-4 bg-white border-2 border-brand rounded-lg space-y-3">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div
            className="text-gray-900"
            style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700 }}
          >
            {item.value}
          </div>
          <div
            className="text-xs text-gray-500 capitalize mt-1"
            style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}
          >
            {item.kind}
          </div>
          {item.code && (
            <div
              className="mt-2 text-sm text-gray-700"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              <span style={{ fontWeight: 700 }}>Verification code:</span>{" "}
              <span className="font-mono text-brand">{item.code}</span>
            </div>
          )}
        </div>
        <button
          onClick={() => onRemove(item)}
          className="text-xs text-red-600 hover:text-red-700 hover:underline"
          style={{ fontFamily: "'Fredoka', sans-serif", fontWeight: 600 }}
        >
          Remove
        </button>
      </div>

      {/* Confirm button */}
      <button
        onClick={() => onConfirm(item)}
        onMouseEnter={() => setHov(true)}
        onMouseLeave={() => { setHov(false); setPress(false); }}
        onMouseDown={() => setPress(true)}
        onMouseUp={() => setPress(false)}
        style={{
          width: "100%",
          padding: "12px 24px",
          background: press ? "#B34428" : hov ? "#C94E30" : "#E05A3A",
          color: "#FFFFFF",
          fontFamily: "'Fredoka', sans-serif",
          fontWeight: 700,
          fontSize: 18,
          border: "3px solid #1A1A1A",
          borderRadius: 50,
          boxShadow: "4px 4px 0px #1A1A1A",
          cursor: "pointer",
          transform: press ? "scale(0.97)" : "scale(1)",
          transition: "all 0.1s ease",
        }}
      >
        Click to View &amp; Confirm Your Handle
      </button>
    </div>
  );
}
